"use strict";
/**
 * Notifications and Mobile pushes
 *
 * Notifications are types used for the in-app notification feed
 *
 * Mobile pushes are payloads delivered to mobile apps
 */
Object.defineProperty(exports, "__esModule", { value: true });
